import React from 'react';
import Breadcrumbs from '../components/Breadcrumbs';
import './TratamientoDatos.css';

const TratamientoDatos = () => {
  return (
    <div className="tratamiento-page">
      <Breadcrumbs />
      <section className="section">
        <div className="container">
          <div className="tratamiento-header">
            <h1 className="page-title">Política de Tratamiento de Datos Personales</h1>
            <p className="page-subtitle">
              La Diócesis de Ipiales se compromete a proteger y respetar la privacidad de los datos personales 
              de los usuarios de este portal, de acuerdo con la Ley 1581 de 2012 y el Decreto 1377 de 2013.
            </p>
          </div>
          
          <div className="tratamiento-content">
            <div className="tratamiento-alert">
              <p className="fecha-actualizacion">
                <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-CO', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            </div>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>1. Responsable del Tratamiento</h2>
              </div>
              <div className="section-content">
                <div className="info-box">
                  <p>
                    <strong>Diócesis de Ipiales, Nariño</strong><br />
                    NIT: [NIT del Diócesis]<br />
                    Dirección: Calle Principal, Ipiales, Nariño<br />
                    Teléfono: +57 (2) XXX-XXXX<br />
                    Correo electrónico: contacto@diocesisdeipiales.org
                  </p>
                </div>
                <p>
                  La Diócesis de Ipiales es la entidad responsable del tratamiento de los datos personales 
                  que se recopilen a través de este portal web y de los servicios que se presten a través del mismo.
                </p>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>2. Finalidad del Tratamiento</h2>
              </div>
              <div className="section-content">
                <p>Los datos personales serán tratados para las siguientes finalidades:</p>
                <ul className="tratamiento-list">
                  <li><strong>Gestionar y responder solicitudes:</strong> Procesar y responder solicitudes de información pública, consultas y requerimientos de los usuarios.</li>
                  <li><strong>Procesar PQRSD:</strong> Gestionar Peticiones, Quejas, Reclamos, Sugerencias y Denuncias presentadas a través del portal.</li>
                  <li><strong>Comunicaciones institucionales:</strong> Enviar comunicaciones relacionadas con servicios institucionales, eventos, actividades y noticias de interés.</li>
                  <li><strong>Cumplimiento legal:</strong> Cumplir con obligaciones legales y normativas aplicables a la Diócesis.</li>
                  <li><strong>Estadísticas y reportes:</strong> Generar estadísticas y reportes institucionales para la mejora continua de los servicios.</li>
                  <li><strong>Gestión administrativa:</strong> Realizar trámites y gestiones administrativas relacionadas con los servicios ofrecidos.</li>
                </ul>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>3. Datos Personales Tratados</h2>
              </div>
              <div className="section-content">
                <p>Tratamos los siguientes datos personales:</p>
                <div className="datos-grid">
                  <div className="dato-categoria">
                    <h3>Datos de Identificación</h3>
                    <ul>
                      <li>Nombre completo</li>
                      <li>Número de documento de identidad</li>
                      <li>Tipo de documento</li>
                    </ul>
                  </div>
                  <div className="dato-categoria">
                    <h3>Datos de Contacto</h3>
                    <ul>
                      <li>Correo electrónico</li>
                      <li>Teléfono fijo y/o celular</li>
                      <li>Dirección de residencia</li>
                    </ul>
                  </div>
                  <div className="dato-categoria">
                    <h3>Datos de Navegación</h3>
                    <ul>
                      <li>Dirección IP</li>
                      <li>Tipo de navegador</li>
                      <li>Páginas visitadas</li>
                      <li>Fecha y hora de acceso</li>
                    </ul>
                  </div>
                  <div className="dato-categoria">
                    <h3>Datos de Solicitudes</h3>
                    <ul>
                      <li>Información contenida en formularios PQRSD</li>
                      <li>Documentos adjuntos</li>
                      <li>Historial de comunicaciones</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>4. Autorización</h2>
              </div>
              <div className="section-content">
                <div className="info-box highlight">
                  <p>
                    Al utilizar este portal y proporcionar sus datos personales, usted autoriza expresamente 
                    a la <strong>Diócesis de Ipiales</strong> para el tratamiento de sus datos personales 
                    de acuerdo con esta política y la normativa vigente en Colombia.
                  </p>
                  <p>
                    La autorización puede ser revocada en cualquier momento, salvo cuando exista un deber legal 
                    o contractual que requiera el tratamiento de los datos.
                  </p>
                </div>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>5. Derechos del Titular</h2>
              </div>
              <div className="section-content">
                <p>De acuerdo con la Ley 1581 de 2012 y el Decreto 1377 de 2013, usted tiene derecho a:</p>
                <div className="derechos-grid">
                  <div className="derecho-item">
                    <h3>Conocer</h3>
                    <p>Acceder de forma gratuita a sus datos personales que hayan sido objeto de tratamiento.</p>
                  </div>
                  <div className="derecho-item">
                    <h3>Actualizar</h3>
                    <p>Rectificar datos inexactos o incompletos, así como solicitar la actualización de los mismos.</p>
                  </div>
                  <div className="derecho-item">
                    <h3>Suprimir</h3>
                    <p>Solicitar la eliminación de sus datos cuando no sean necesarios o cuando se haya revocado la autorización.</p>
                  </div>
                  <div className="derecho-item">
                    <h3>Revocar</h3>
                    <p>Retirar la autorización para el tratamiento de sus datos personales en cualquier momento.</p>
                  </div>
                  <div className="derecho-item">
                    <h3>Solicitar Prueba</h3>
                    <p>Obtener copia de la autorización otorgada para el tratamiento de sus datos personales.</p>
                  </div>
                  <div className="derecho-item">
                    <h3>Presentar Quejas</h3>
                    <p>Presentar quejas ante la Superintendencia de Industria y Comercio por infracciones a la normativa de protección de datos.</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>6. Procedimiento para Ejercer Derechos</h2>
              </div>
              <div className="section-content">
                <p>Para ejercer sus derechos, puede realizar su solicitud a través de los siguientes medios:</p>
                <div className="procedimiento-box">
                  <div className="procedimiento-item">
                    <h3>Correo Electrónico</h3>
                    <p>
                      Envíe una solicitud escrita al correo electrónico:<br />
                      <strong>contacto@diocesisdeipiales.org</strong>
                    </p>
                  </div>
                  <div className="procedimiento-item">
                    <h3>Presentación Física</h3>
                    <p>
                      Presente su solicitud físicamente en las oficinas de la Diócesis de Ipiales, 
                      ubicadas en la dirección indicada en la sección 1.
                    </p>
                  </div>
                </div>
                <div className="info-box">
                  <p>
                    <strong>Requisitos de la solicitud:</strong>
                  </p>
                  <ul>
                    <li>Identificación del titular o su representante legal</li>
                    <li>Descripción clara de los datos sobre los cuales se busca ejercer el derecho</li>
                    <li>Derecho que se desea ejercer</li>
                    <li>En caso de revocatoria, la manifestación expresa de retirar el consentimiento</li>
                  </ul>
                  <p>
                    <strong>Plazo de respuesta:</strong> La Diócesis de Ipiales responderá su solicitud 
                    en un plazo máximo de 10 días hábiles contados a partir de la fecha de recepción.
                  </p>
                </div>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>7. Medidas de Seguridad</h2>
              </div>
              <div className="section-content">
                <p>
                  La Diócesis de Ipiales implementa medidas técnicas y organizativas para proteger sus datos personales, 
                  garantizando su confidencialidad, integridad y disponibilidad:
                </p>
                <div className="medidas-grid">
                  <div className="medida-item">
                    <h3>Medidas Técnicas</h3>
                    <ul>
                      <li>Encriptación de datos sensibles en tránsito y en reposo</li>
                      <li>Control de acceso mediante autenticación y autorización</li>
                      <li>Firewalls y sistemas de detección de intrusiones</li>
                      <li>Copias de seguridad regulares y automatizadas</li>
                      <li>Actualización constante de sistemas y software</li>
                    </ul>
                  </div>
                  <div className="medida-item">
                    <h3>Medidas Organizativas</h3>
                    <ul>
                      <li>Capacitación continua del personal en protección de datos</li>
                      <li>Políticas y procedimientos internos de seguridad</li>
                      <li>Control de acceso físico a las instalaciones</li>
                      <li>Auditorías periódicas de seguridad</li>
                      <li>Plan de respuesta ante incidentes de seguridad</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <section className="tratamiento-section">
              <div className="section-header">
                <h2>8. Vigencia y Modificaciones</h2>
              </div>
              <div className="section-content">
                <p>
                  Esta política de tratamiento de datos personales estará vigente mientras la Diócesis de Ipiales 
                  mantenga activo su portal web y los servicios asociados.
                </p>
                <div className="info-box">
                  <p>
                    <strong>Modificaciones:</strong> La Diócesis de Ipiales se reserva el derecho de modificar 
                    esta política cuando sea necesario, notificando los cambios a través del portal web. 
                    Se recomienda revisar periódicamente esta política para estar informado sobre cómo protegemos sus datos.
                  </p>
                  <p>
                    <strong>Contacto:</strong> Para cualquier consulta, solicitud o queja relacionada con el 
                    tratamiento de datos personales, puede contactarnos a través de los medios indicados en la sección 1.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TratamientoDatos;

















